import { http, HttpResponse, delay } from 'msw';

import {
  adpCredentialsExistResponse,
  createHrisIntegrationResponse,
  hrisProviders,
  hrisSyncStatusResponse,
  hrisSyncWorkflowResponse,
  simpleHrisIssue,
} from '../data/hrisIntegrationData';

type LinkTokenDto = {
  link_token: string;
};

const linkTokenResponse: LinkTokenDto = {
  link_token: 'test_link_token',
};

export const hrisIntegrationHandlers = [
  http.post('*/v1/organizations/:id/hris_integrations/link_token', async () => {
    await delay();
    return HttpResponse.json(linkTokenResponse, { status: 201 });
  }),
  http.get(
    `*/v1/organizations/:organizationId/hris_integrations/:hrisIntegrationId/issues`,
    async () => {
      await delay();
      return HttpResponse.json({ issues: [simpleHrisIssue] }, { status: 200 });
    }
  ),
  http.get('*/v1/hris_providers', async () => {
    await delay();
    return HttpResponse.json(hrisProviders, { status: 200 });
  }),
  // Literal path before the `:hrisIntegrationId` routes below.
  http.post(
    '*/v1/organizations/:organizationId/hris_integrations/demo_sync_employee',
    async () => {
      await delay();
      return new HttpResponse(null, { status: 204 });
    }
  ),
  http.post(
    '*/v1/organizations/:organizationId/hris_integrations',
    async () => {
      await delay();
      return new HttpResponse(null, { status: 201 });
    }
  ),
  http.post(
    '*/v2/organizations/:organizationId/hris_integrations',
    async ({ params, request }) => {
      const body = (await request.json()) as { hris_provider_slug: string };
      await delay();
      return HttpResponse.json(
        createHrisIntegrationResponse(
          params.organizationId as string,
          body.hris_provider_slug
        ),
        { status: 201 }
      );
    }
  ),
  http.patch(
    '*/v1/organizations/:organizationId/hris_integrations/:hrisIntegrationId',
    async () => {
      await delay();
      return new HttpResponse(null, { status: 204 });
    }
  ),
  http.delete(
    '*/v1/organizations/:organizationId/hris_integrations/:hrisIntegrationId',
    async () => {
      await delay();
      return new HttpResponse(null, { status: 204 });
    }
  ),
  http.delete(
    '*/v2/organizations/:organizationId/hris_integrations/:hrisIntegrationId',
    async () => {
      await delay();
      return new HttpResponse(null, { status: 204 });
    }
  ),
  http.post(
    '*/v2/organizations/:organizationId/hris_integrations/:hrisIntegrationId/disconnect',
    async () => {
      await delay();
      return new HttpResponse(null, { status: 204 });
    }
  ),
  http.post(
    '*/v1/organizations/:organizationId/hris_integrations/:hrisIntegrationId/sync',
    async () => {
      await delay();
      return new HttpResponse(null, { status: 204 });
    }
  ),
  http.post(
    '*/v2/organizations/:organizationId/hris_integrations/:hrisIntegrationId/sync',
    async () => {
      await delay();
      return HttpResponse.json(hrisSyncWorkflowResponse, { status: 200 });
    }
  ),
  http.get(
    '*/v2/organizations/:organizationId/hris_integrations/:hrisIntegrationId/sync/:workflowId/status',
    async () => {
      await delay();
      return HttpResponse.json(hrisSyncStatusResponse, { status: 200 });
    }
  ),
  http.get(
    '*/v1/organizations/:organizationId/hris_integrations/:hrisIntegrationId/adp_credentials/fetch',
    async () => {
      await delay();
      return HttpResponse.json(adpCredentialsExistResponse, { status: 200 });
    }
  ),
];
